import { wingPicOf, type CombatantView, type PlayerLook, type WornPiece } from '@ddt/game-engine';
import { weaponPicsAt, type ItemTemplate, type WeaponLevels } from './stores/catalog';

/** Ids de modelo da lista de peças do Character (`Style`: ids separados por vírgula; vazio = sem peça; `id|x` guarda o id antes da barra). */
export function styleIds(style: string): number[] {
  return style
    .split(',')
    .map((part) => Number(part.split('|')[0]))
    .filter((id) => Number.isInteger(id) && id > 0);
}

/** Todos os modelos que o visual de um jogador usa: as peças da lista e a arma. */
export function lookTemplateIds(c: Pick<CombatantView, 'style' | 'weaponTemplateId'>): number[] {
  return c.weaponTemplateId > 0 ? [...styleIds(c.style), c.weaponTemplateId] : styleIds(c.style);
}

/**
 * Aparência de um jogador na partida, a partir do catálogo. Modelo ainda não consultado fica de fora: o jogador usa o visual padrão
 * dessa peça até o catálogo responder e a tela chamar de novo. A arma vem do `weaponTemplateId` (o que conta no combate), não do `Style`.
 */
export function lookOf(
  c: Pick<CombatantView, 'sex' | 'style' | 'weaponTemplateId'> & { weaponStrengthenLevel?: number },
  templates: Record<number, ItemTemplate | null | undefined>,
  weaponLevels: WeaponLevels = {},
): PlayerLook {
  const worn: WornPiece[] = styleIds(c.style).flatMap((id) => {
    const t = templates[id];
    return t && t.categoryId !== 7 ? [{ categoryId: Number(t.categoryId), pic: t.pic ?? '', fullHair: !!t.showsFullHair, templateId: id }] : [];
  });
  const weapon = c.weaponTemplateId > 0 ? templates[c.weaponTemplateId] : null;
  // Asa sem arte na partida (o atlas do manifest é conferido pelo desenho): `wingPicOf` só descarta a padrão.
  return { sex: c.sex ? 'm' : 'f', worn, weaponPic: weaponPicsAt(weaponLevels, c.weaponTemplateId, c.weaponStrengthenLevel ?? 0).lookPic ?? weapon?.pic ?? '', wingPic: wingPicOf(worn, () => true) };
}

/** As peças do boneco em pé: as equipadas e a arma na mão (categoria 7), como o `ShowCharacter` do legado. */
export function showWornOf(look: PlayerLook): WornPiece[] {
  return look.weaponPic ? [...look.worn, { categoryId: 7, pic: look.weaponPic }] : [...look.worn];
}
